/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles } from 'utils/themeV2';



/* ++++++++++ --------------- EXPORT : ACCOUNT USERS : STYLES --------------- ++++++++++ */
export default theme => ({
    users: {
        '& .table': {
            '& button': {
                fontSize: pxToEm(14),
                height: pxToEm(30),
                width: 'fit-content'
            }
        },
        ...buttonStyles
    }
});
